import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { T } from "../../constants";

const useStyles = makeStyles({
  label: { display: "block" },
  caption: {
    display: "block",
    marginBottom: 4,
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    color: T.mutedFg,
  },
});

export default function Field({ label, children, className }) {
  const s = useStyles();
  return (
    <label className={className ? `${s.label} ${className}` : s.label}>
      <span className={s.caption}>{label}</span>
      {children}
    </label>
  );
}
